
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import HeroSection from './components/HeroSection';
import WhyChooseSection from './components/WhyChooseSection';
import ServicesSection from './components/ServicesSection';
import StatsSection from './components/StatsSection';
import TestimonialsSection from './components/TestimonialsSection';
import TrustBadgesSection from './components/TrustBadgesSection';
import FinalCTASection from './components/FinalCTASection';

export default function HomePage() {
  return (
    <div className="min-h-screen">
      <Header />
      <main>
        <HeroSection />
        <WhyChooseSection />
        <ServicesSection />
        <StatsSection />
        <TestimonialsSection />
        <TrustBadgesSection />
        <FinalCTASection />
      </main>
      <Footer />
    </div>
  );
}
